var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAstro = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 246 200",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 4"
}, /*#__PURE__*/React.createElement("path", {
  d: "m239.63 94.665-118.347 49.652-20.508-52.282a.824.824 0 0 1 .01-.628l11.2-25.988 79.354-29.021 31.786 11.416a.903.903 0 0 1 .548.556Z",
  style: {
    fill: "#b0b0ea"
  }
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M223.125 47.814 100.786 91.407l11.199-25.988 79.354-29.021 31.786 11.416z"
})), /*#__PURE__*/React.createElement("path", {
  d: "m195.441 49.541-75.725 24.26-8.854-42.624 5.956-3.707a125.429 125.429 0 0 1 53.46-18.257l5.303-.54Z",
  style: {
    fill: "#b0b0ea"
  }
}), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m175.58 8.674-11.288-4.385s-28.394 3.372-48.446 17.39l-4.984 9.498s30.933-19.36 64.719-22.503Z"
})), /*#__PURE__*/React.createElement("path", {
  d: "m49.784 141.154-22.783-16.168a1.228 1.228 0 0 0-1.854.552 5.5 5.5 0 0 0 1.65 6.284l16.244 13.194 1.668 1.43",
  style: {
    fill: "#b0b0ea"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m49.112 148.468-17.915-12.534a.961.961 0 0 0-1.448.442 4.304 4.304 0 0 0 1.324 4.91l12.782 10.24 1.313 1.11",
  style: {
    fill: "#b0b0ea"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m26.797 131.822 16.244 13.194 1.668 1.43",
  style: {
    fill: "none",
    stroke: "#6e6bb3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.1414549103516938px"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m44.362 138.517-1.32-2.345-13.634-22.81a5.457 5.457 0 0 1 .6-6.417 2.239 2.239 0 0 1 3.518.213l18.898 27.402",
  style: {
    fill: "#b0b0ea"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M247.656 84.82s-9.755-10.869-35.116-5.574a7.876 7.876 0 0 0-8.202-3.356l-1.474.312s-1.84-4.991-3.867-4.885l-29.377 22.7-33.165 1.394s-.836 4.18 1.393 5.853c0 0-4.738 1.114-4.459 7.246 0 0-28.427 18.115-29.542 42.362s40.133 49.887 40.133 49.887h101.725s2.369-116.357 1.95-115.939Z",
  style: {
    fill: "#ccdff9"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.946 171.496s-13.934-20.067-32.607-20.624c0 0-10.312-8.64-23.132-8.082-10.317.448-17.558 6.131-19.788 11.148s-14.492 25.361 17.28 39.854l41.526 13.935 22.295-1.394",
  style: {
    fill: "#ccdff9"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.946 171.496s-13.934-20.067-32.607-20.624",
  style: {
    fill: "none",
    stroke: "#6e6bb3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.1414549103516938px"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m207.158 43.53-14.013 5.44-8.64-21.75a8.49 8.49 0 0 1 4.84-10.986 8.49 8.49 0 0 1 10.987 4.841l7.921 19.941a1.93 1.93 0 0 1-1.095 2.513Z",
  style: {
    fill: "#ccdff9"
  }
}), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m195.163 16.04-8.236-2.77s-6.21 0-7.098 4.615l4.675 9.335s-.26-6.623 3.488-9.69a7.38 7.38 0 0 1 7.17-1.49Z"
})), /*#__PURE__*/React.createElement("ellipse", {
  cx: 194.202,
  cy: 26.157,
  rx: 2.764,
  ry: 2.879,
  style: {
    fill: "#6e6bb3"
  }
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 198.554,
  cy: 36.461,
  rx: 2.764,
  ry: 2.879,
  style: {
    fill: "#6e6bb3"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m123.878 71.097-14.296 5.55a1.675 1.675 0 0 1-2.156-.924l-8.512-20.708a8.49 8.49 0 0 1 4.841-10.986 8.49 8.49 0 0 1 10.986 4.841Z",
  style: {
    fill: "#ccdff9"
  }
}), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "m100.027 46.895 4.267-7.273s4.853-3.876 8.426-.824l2.172 10.212a10.55 10.55 0 0 0-8.772-5.395c-3.468-.192-6.093 3.28-6.093 3.28Z"
})), /*#__PURE__*/React.createElement("ellipse", {
  cx: 110.89,
  cy: 64.634,
  rx: 2.764,
  ry: 2.879,
  style: {
    fill: "#6e6bb3"
  }
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 107.31,
  cy: 54.916,
  rx: 2.764,
  ry: 2.879,
  style: {
    fill: "#6e6bb3"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.34 96.557c-24.019-6.513-36.397-51.294-5.089-71.038 22.187-13.637 55.925-8.82 66.153 21.17 12.009 35.213-30.3 58.09-61.064 49.868Z",
  style: {
    fill: "#ccdff9"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M175.416 21.22c10.538 4.046 19.513 12.348 23.988 25.468m-81.044 30.77a43.765 43.765 0 0 1-1.43-32.04 37.818 37.818 0 0 1 5.37-9.936m77.25 34.236c-7.316 19.96-33.922 31.468-56.423 27.857a48.014 48.014 0 0 1-4.787-1.018",
  style: {
    fill: "none",
    stroke: "#6e6bb3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.1414549103516938px"
  }
}), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M141.794 92.872c-20.483-5.555-31.04-43.745-4.34-60.583 18.921-11.63 47.694-7.522 56.417 18.053 10.241 30.031-25.84 49.542-52.077 42.53Z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M141.19 101.85s17.504 6.31 37.655-3.868c19.291-9.743 22.798-19.133 22.798-19.133",
  style: {
    fill: "none",
    stroke: "#6e6bb3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.1414549103516938px"
  }
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#b0b0ea"
  },
  d: "m149.594 189.526-7.864-18.361 13.976-6.58-10.636-29.2 30.244-11.314-1.92-5.427 40.758-14.747 12.513 33.224 10.015-4.252 14.71 40.914.186 27.828-97.12-4.794-4.862-7.291z"
}), /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-20.27 168.589 147.66)",
  style: {
    fill: "#ccdff9"
  },
  d: "M155.499 135.298h26.178v24.722h-26.178z"
}), /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-20.27 199.456 128.281)",
  style: {
    fill: "#ccdff9"
  },
  d: "M181.997 115.92h34.916v24.722h-34.916z"
}), /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-20.27 210.317 155.558)",
  style: {
    fill: "#ccdff9"
  },
  d: "M192.858 143.197h34.916v24.722h-34.916z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 176.996,
  cy: 169.58,
  r: 4.99,
  style: {
    fill: "#ccdff9"
  }
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "none",
    stroke: "#6e6bb3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.1414549103516938px"
  },
  d: "m224.769 144.296-32.755 12.097m21.422-40.65-32.755 12.096m-2.603 7.733-24.558 9.07m-50.842 7.971s8.11 2.95 12.35 10.323"
}), /*#__PURE__*/React.createElement("path", {
  d: "m59.752 131.775-18.897-27.402a2.239 2.239 0 0 0-3.52-.213 5.457 5.457 0 0 0-.598 6.418l13.634 22.809 1.32 2.345",
  style: {
    fill: "#b0b0ea"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m36.737 110.578 13.634 22.809 1.32 2.345M30.75 114.947l13.634 22.809 1.32 2.345",
  style: {
    fill: "none",
    stroke: "#6e6bb3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.1414549103516938px"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M61.658 131.481s-18.762 2.785-19.641 13.485 18.322 3.518 18.322 3.518l6.45-11.58Z",
  style: {
    fill: "#b0b0ea"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.674 132.8s-13.192 1.173-14.071 11.873",
  style: {
    fill: "none",
    stroke: "#6e6bb3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.1414549103516938px"
  }
}), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M55.162 163.316s8.236 7.152 16.255.217a13.64 13.64 0 0 0 3.251-17.34c-1.084-1.516-20.373 11.705-20.373 11.705Z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M40.55 148.924s14.978 19.675 24.798 13.958 12.14-11.32 7.01-22.02c-4-8.343-5.505-15.44-4.098-19.342a1.841 1.841 0 0 0-2.164-2.41c-3.692.903-8.194 4.616-5.61 18.088 0 0-5.13-.88-6.597 4.25",
  style: {
    fill: "#b0b0ea"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M66.096 119.11c-3.692.903-8.194 4.616-5.61 18.088 0 0-5.13-.88-6.597 4.25",
  style: {
    fill: "none",
    stroke: "#6e6bb3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.1414549103516938px"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M129.218 65.7a29.646 29.646 0 0 0 7.463 15.627m-4.183-34.025a28.231 28.231 0 0 0-2.553 6.627",
  style: {
    fill: "none",
    stroke: "#f1e9ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "3.04387976093785px"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.174 103.846s-11.97 11.509-7.14 23.608m7.118-16.008s-7.349 11.668-.844 20.385",
  style: {
    fill: "none",
    stroke: "#6e6bb3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.1414549103516938px"
  }
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAstro);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/astro.ed25da6378107dc0ea0c837703733cfc.svg";